import { ActivityIndicator, type ActivityIndicatorProps } from 'react-native';

// Issue #147 AC5. A bare `<ActivityIndicator />` carries no
// announcement to a screen reader on its own -- confirmed by reading
// RN's own ActivityIndicator source (it renders no default
// accessibility role or label; a sighted user infers "loading" from
// the spinning glyph, a screen reader user gets nothing). Grepped
// every remaining standalone spinner (not the button-content-swap
// pattern PrimaryButton's own new `loading` prop covers) across the
// app -- reveal-requests/matches/profile/profile-view/threads' first-
// load and pagination-footer spinners, plus AuthenticatedImage's and
// LocationCard's own loading states -- and this one wrapper replaces
// all of them.
//
// `role`/`aria-label`, not `accessibilityRole`/`accessibilityLabel` --
// this app's own established pattern (see skeleton.tsx's own comment
// for the real render-confirmed reasoning: Tamagui's own components
// don't translate the RN-specific props to real DOM/ARIA on web, and
// RN 0.86's newer cross-platform props do, on both platforms).
// ActivityIndicator is a real react-native core component, not a
// Tamagui one, so this precaution is arguably unnecessary here -- but
// using the same prop pair as every other loading indicator in this
// app keeps one consistent, known-safe pattern rather than two.
export function LoadingIndicator({ label = 'Loading', ...props }: ActivityIndicatorProps & { label?: string }) {
  return <ActivityIndicator role="progressbar" aria-label={label} {...props} />;
}
